import { useMutation } from '@tanstack/react-query';

import { CompleteRegistrationRequest, getSMPBackendAPIPublic } from '@/proxy-web';

function completeRegistration(request: CompleteRegistrationRequest): Promise<void> {
  return getSMPBackendAPIPublic().requestControllerCompleteRegistrationV1(request);
}

export function useCompleteRegistration() {
  return useMutation({ mutationFn: completeRegistration });
}
